import React from 'react';

import { useSelector } from 'react-redux';

import { ModalTransition } from '@atlaskit/onboarding';

import { DiffMetadataProps } from 'src/components/diff-set/diff-set';
import { getIsDiffSettingsDialogOpen } from 'src/redux/diff-settings';
import { getIsViewEntireFileDialogOpen } from 'src/redux/pull-request/view-entire-file-reducer';
import { DiffSettingsDialog } from 'src/sections/repository/sections/pull-request/components/diff-settings';

import { ViewEntireFileDialog } from '../../pull-request/components/view-entire-file';
import { useBranchViewEntireFileState } from '../../pull-request/components/view-entire-file/hooks';

interface Props {
  diffMetadataProps: DiffMetadataProps;
}

export const CommitDialogZone = ({ diffMetadataProps }: Props) => {
  const isViewEntireFileDialogOpen = useSelector(getIsViewEntireFileDialogOpen);
  const isDiffSettingsDialogOpen = useSelector(getIsDiffSettingsDialogOpen);

  return (
    <ModalTransition>
      {isViewEntireFileDialogOpen && (
        <ViewEntireFileDialog
          useViewEntireFileState={useBranchViewEntireFileState}
          allowComments={false}
          diffMetadataProps={diffMetadataProps}
        />
      )}
      {isDiffSettingsDialogOpen && <DiffSettingsDialog disableAnnotations />}
    </ModalTransition>
  );
};
